import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { error: undefined, errorInfo: undefined };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo,
        });
    }
    render() {
        const { error, errorInfo } = this.state;
        if (errorInfo) {
            const errorDetails = process.env.NODE_ENV === 'development' ? (_jsxs("details", { className: "preserve-space", children: [error && error.toString(), _jsx("br", {}), errorInfo.componentStack] })) : undefined;
            return (_jsxs("div", { children: [_jsx("h2", { className: "error", children: "An unexpected error has occurred." }), errorDetails] }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
